// Build60 mutations refresh discovery on both HOME and SEARCH. Album/review
// metadata also feeds divided opinion and reviewer cards; playlist edits do not.
export function isHomePersonalization(key, kind = 'album') {
  if (key[0] === 'web-discovery') return true;
  return (
    kind !== 'playlist' &&
    ['web-divided-album', 'web-member-reviews', 'web-reviewer-candidates', 'web-members'].includes(
      key[0],
    )
  );
}

export async function invalidateHomePersonalization(client, kind = 'album') {
  const filter = { predicate: ({ queryKey }) => isHomePersonalization(queryKey, kind) };
  await client.cancelQueries(filter);
  await client.invalidateQueries(filter);
}

// Explicit refresh is narrower than a mutation invalidation: only reads currently
// used by this Home identity, never cached Search or another account/locale.
export function isActiveHomeRead(key, { userId, version, locale }) {
  const identity = (value) => Array.isArray(value) && value[0] === version && value[1] === locale;
  if (key[0] === 'web-discovery')
    return (
      key[1] === (userId || 'guest') && key[2] === 'home' && key[3] === locale && key[4] === version
    );
  if (key[0] === 'web-home-fallback')
    return key[2] === (userId || 'guest') && key[3] === locale && key[4] === version;
  if (key[0] === 'web-parity')
    return key[1] === 'explore' && key[2] === 'home' && key[3] === version && key[4] === locale;
  if (key[0] === 'web-divided-album') return identity(key[2]);
  if (key[0] === 'web-member-reviews') return identity(key[3]);
  if (key[0] === 'web-reviewer-candidates') return identity(key[1]);
  if (['web-members', 'web-following'].includes(key[0]))
    return key[1] === userId && identity(key[2]);
  if (key[0] === 'home-banners') return key[1] === 'app-inventory' && key[2] === locale;
  return key[0] === 'public-events' && key[1] === 'home' && key[2] === locale;
}
export async function refreshHomeReads(client, identity) {
  const filter = {
    type: 'active',
    predicate: (query) => isActiveHomeRead(query.queryKey, identity),
  };
  // New retain IDs have already been committed synchronously by selection.advance().
  await client.cancelQueries(filter);
  await client.refetchQueries(filter);
}
